import React, { useState } from 'react';
import { makeStyles, Grid, Button, Icon } from '@material-ui/core';
import MethodCard from './MethodCard';
import MethodAddEditModal from './MethodAddEditModal';

////////// COMPONENT //////////
export default function MethodTable(props) {
  const cls = useStyles();

  const [modal, setModal] = useState({ open: false });

  const { methods } = props;

  const handleModalOpen = () => {
    setModal({ ...modal, open: true });
  }
  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  }

  return (<>
    <MethodAddEditModal open={modal.open} onClose={handleModalClose} />

    <div className={cls.root}>
      <Grid container spacing={3}>
        {methods.length > 0 ?
          methods.map(m =>
            <React.Fragment key={m.id}>
              <Grid item md={6} xs={12}>
                <MethodCard method={m} />
              </Grid>
            </React.Fragment>
          ) : null
        }
        <React.Fragment key={0}>
          <Grid item md={6} xs={12}>
            <Button className={cls.addButton} variant="outlined" color="primary" style={{ fontSize: '16px' }} onClick={() => handleModalOpen()}><Icon className={cls.addIcon}>add</Icon>Add Payment Method</Button>
          </Grid>
        </React.Fragment>
      </Grid>
    </div>
  </>)
}

////////// STYLES //////////
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  addButton: {
    width: '100%',
    height: '100%',
    minHeight: '198px',
    padding: '24px',
  },
  addIcon: {
    marginTop: '-2px',
    marginRight: theme.spacing(1),
    fontSize: '16px',
  },
}));